import CryptoJS from 'crypto-js';

/**
 * 加密
 */
export const encrypt = (word, pwd) => {
  const key = CryptoJS.enc.Utf8.parse(pwd);
  const srcs = CryptoJS.enc.Utf8.parse(word);
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};
/**
 * 解密
 */
export const decrypt = (word, pwd) => {
  if (!word) {
    return '';
  }
  const key = CryptoJS.enc.Utf8.parse(pwd);
  const decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
};
